import React from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form } from "shards-react";
import { TiEdit } from "react-icons/ti";

import FunctionDataService from "../../services/function.service";
import { FcPlus } from "react-icons/fc";
import { FcAcceptDatabase } from "react-icons/fc";
import { ToastContainer } from "react-toastify";

class DetailFunctionSuperAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      functionDetails: {},
    };
  }

  componentDidMount() {
    if (this.props.functionId) this.retrieveFunctionDetails();
  }

  retrieveFunctionDetails() {
    FunctionDataService.get(this.props.functionId).then((response) => {
      this.setState({ functionDetails: response.data.data });
    });
  }

  render() {
    const { functionName, procedureName, parameters } = this.state.functionDetails;
    const { functionId } = this.props;

    return (
      <div>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Transation Function Details
              <Link className="btn btn-primary ml-4" to={"/view-function-superadmin"}><FcAcceptDatabase /> View All</Link>
            </h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="functionName">Function Name</label>
                      </Col>
                      <Col className="form-field" md="9">
                        {functionName}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="procedureName">Stored Procedure Name</label>
                      </Col>
                      <Col className="form-field" md="9">
                        {procedureName}
                      </Col>
                    </Row>

                    <Row className="form-group-row border-bottom-button">
                      <Col className="form-label" md="3">
                        <label htmlFor="masterTransactionFields">Stored Procedure Parameters </label>
                      </Col>
                      <Col className="form-field" md="9">
                        <Row className="form-group-row ml-1 mr-1 border-bottom-button">
                          <Col className="form-label" md="5">
                            <label htmlFor="parameterName">Parameter Name</label>
                          </Col>
                          <Col className="form-label" md="4">
                            <label htmlFor="source">Source</label>
                          </Col>
                          <Col className="form-label" md="3">
                            <label htmlFor="dataType">Data Type</label>
                          </Col>
                        </Row>
                        {parameters && parameters.length ? (
                          parameters.map((item, index) => {
                            return (
                              <Row className="form-group-row ml-1 mr-1 border-bottom-button" key={index + 1}>
                                <Col className="form-field" md="5">
                                  {item.parameterName}
                                </Col>
                                <Col className="form-field" md="4">
                                  {item.source}
                                </Col>
                                <Col className="form-field" md="3">
                                  {item.dataType}
                                </Col>
                              </Row>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-button" md="4">
                        <Link className="btn btn-primary" to={"/function/" + functionId + "/edit"}>
                          <TiEdit /> Edit Function
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>
        <ToastContainer />
      </div>
    );
  }
}

export default DetailFunctionSuperAdmin;
